export default "__VITE_ASSET__f03715f6__"